/** Public browser path prefix (visible in Network tab). */
export const KEYWORDYAB_API_PREFIX =
  import.meta.env.VITE_KEYWORDYAB_API_PREFIX?.replace(/\/$/, '') || '/api';

/**
 * Base URL for KeywordYab API calls from the browser.
 * Empty → same-origin + VITE_KEYWORDYAB_API_PREFIX (recommended).
 */
export const KEYWORDYAB_BACKEND_URL = (() => {
  const raw = import.meta.env.VITE_KEYWORDYAB_BACKEND_URL?.trim();
  if (!raw) {
    return KEYWORDYAB_API_PREFIX;
  }
  if (raw.startsWith('/')) {
    return raw.replace(/\/$/, '');
  }
  return raw.replace(/\/$/, '');
})();
